const addClassToElement = (element, classToAdd) => {
    if(isEmpty(element) || isEmpty(classToAdd)){
        return;
    }

    if(element instanceof jQuery){
        element.addClass(Array.isArray(classToAdd) ? classToAdd.join(",") : classToAdd);
        return;
    }

    classToAdd = !Array.isArray(classToAdd) ? classToAdd.split(",").map(c => c.trim()) : classToAdd;
    element.classList.add(classToAdd);
}

const addClassToElements = (elements, classToAdd) => {
    if(isEmpty(elements) || isEmpty(classToAdd)){
        return;
    }

    if(elements instanceof jQuery){
        addClassToElement(elements, classToAdd);
    }
    else {
        elements = getElements(elements);
        if(elements instanceof Element){
            addClassToElement(elements, classToAdd);
        } else{
            elements.forEach(e => addClassToElement(e, classToAdd));
        }
    }
}

const catchElementHidden = (selector) => {
    return new Promise((resolve, reject) => {
        let element = document.querySelector(selector);
        if (!isEmpty(element) && !isVisible(element)) {
            resolve(element);
        }

        waitForElement(selector).then(element => resolve(element));
    });
}

/**
 * Disabled the specified element
 * @param {String|Element|jQuery} element element to disable;
 */
const disableElement = (element) => {
    // Legacy, remove once jQuery library is removed
    if(element instanceof jQuery){
        element.prop('disabled', true);
        return;
    }
    let el = getElement(element);

    if(!isUndefinedOrNull(el)){
        el.disabled = true;
    }
}

const disableElements = (elements) => {
    if(elements instanceof jQuery || elements instanceof Element){
        disableElement(elements);
        return;
    }

    for(const el of getElements(elements)){
        disableElement(el);
    }
}

/**
 * This method will enable the provided Element
 * @param {Element|String|jQuery} element Element to enable
 */
const enableElement = (element) => {
    // Legacy, remove once jQuery library is removed
    if(element instanceof jQuery){
        element.prop('disabled', false)
        return;
    }

    let el = getElement(element);

    if(!isUndefinedOrNull(el)){
        el.disabled = false;
    }
};

const enableElements = (elements) => {
    if(elements instanceof jQuery || elements instanceof Element){
        enableElement(elements);
        return;
    }

    for(const el of getElements(elements)){
        enableElement(el);
    }
}

/**
 * This will return the Element that matches the CSS selector provided
 * @param {String|Element} selector CSS Selector for the desired element
 * @return {null|Element} First DOM Element that matches the CSS Selector provided
 */
const getElement = (selector) => {
    if (isUndefinedOrNull(selector)) {
        return null;
    }

    if (typeof selector === 'string') {
        return document.querySelector(selector);
    } else if (selector instanceof Element) {
        return selector;
    }

    // Should never reach here but just in case
    throw Error('selector provided is not valid');
}

/**
 * This will return all the Elements that match the CSS selector provided
 * @param {String|Element|NodeList} selector CSS Selector for the desired element
 * @return {null|NodeList<Element>} All DOM Element that matches the CSS Selector provided
 */
const getElements = (selector) => {
    if(isUndefinedOrNull(selector)){
        return null;
    }

    if(typeof selector === 'string'){
        return document.querySelectorAll(selector);
    }
    else if(selector instanceof Element || selector instanceof NodeList || Array.isArray(selector)){
        return selector;
    }

    // Should never reach here but just in case
    throw Error('selector provided is not valid');
}

const hideElement = (element, removeElementSpace = true) => {
    // Legacy, remove once jQuery library is removed
    if(element instanceof jQuery){
        if (removeElementSpace) {
            element.hide();
        } else {
            element.css('visibility', 'hidden');
        }

        return;
    }

    let el = getElement(element);
    if(!isUndefinedOrNull(el)){
        if (getComputedStyle(el).display !== 'none') {
            el.dataset.xxxDisplay = getComputedStyle(el).display;
        }
        if(removeElementSpace) {
            el.style.display = 'none';
        }
        else {
            el.style.visibility = 'hidden';
        }
    }
};

function hideElements(elements) {
    elements = getElements(elements) || [];
    elements.forEach(element => hideElement(element));
}

/**
 * Checks to see if the element is disabled
 * @param {Element|String} element Element (or CSS Selector) to check
 * @return {Boolean|null} Is the element disabled or not, returns null if element is not found.
 */
const isElementDisabled = (element) => {
    // Legacy, remove once jQuery library is removed
    if(element instanceof jQuery) {
        return element.prop('disabled');
    }

    let el = getElement(element);
    if(!isUndefinedOrNull(el)){
        return el.disabled;
    }

    return null;
};

const isVisible = (elem) => {
    elem = getElement(elem);
    return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length /* && window.getComputedStyle(elem).visibility !== "hidden"*/);
};

/**
 * This method will fire when entire window is loaded (everything) or immediately if window is already loaded
 * @param {Function} functionToRun function to run when window is loaded
 */
const onDocLoad = (functionToRun) => {
    if (document.readyState === "complete") {
        functionToRun();
    }
    else {
        window.addEventListener("load", functionToRun);
    }
};

/**
 * This method will fire when DOM and scripts are downloaded and parsed
 * @param {Function} functionToRun function to run when DOM is ready
 */
const onDocReady = (functionToRun) => {
    if (document.readyState !== "loading") {
        functionToRun();
    }
    else {
        window.addEventListener("DOMContentLoaded", functionToRun);
    }
}

const onClick = (selector, callback) =>
    document.querySelectorAll(selector).forEach(element => element.addEventListener('click', callback));

/**
 * This method will remove all DOM elements that match the provided selector
 * @param {String} selector CSS Selector to use for lookup
 */
const removeElements =
    (selector) => document.querySelectorAll(selector).forEach(el => el.remove());

const removeClassFromElement = (element, classToAdd) => {
    if(isEmpty(element) || isEmpty(classToAdd)){
        return;
    }

    if(element instanceof jQuery){
        element.removeClass(Array.isArray(classToAdd) ? classToAdd.join(",") : classToAdd);
        return;
    }

    classToAdd = !Array.isArray(classToAdd) ? classToAdd.split(",").map(c => c.trim()) : classToAdd;
    element.classList.remove(classToAdd);
}

const removeClassFromElements = (elements, classToAdd) => {
    if(isEmpty(elements) || isEmpty(classToAdd)){
        return;
    }


    if(elements instanceof jQuery){
        removeClassFromElement(elements, classToAdd);
    } else {
        elements = getElements(elements);
        if(elements instanceof Element){
            removeClassFromElement(elements, classToAdd);
        } else{
            elements.forEach(e => removeClassFromElement(e, classToAdd));
        }
    }
}

/**
 * This function takes a list of htmlElement selectors, for each selector (String), wait for element, then hide element
 * if wait for
 * @param {String} htmlElementList
 * @returns {Promise<void>}
 */
async function removeHtmlElements(htmlElementList) {
    for (const htmlElementListKey of htmlElementList) {
        waitForElement(htmlElementListKey).then((el) => {
            hideElement(el, true);
        });
    }
}

/**
 * This method will set a CSS Property value
 * @param {String} selector Selector to use for lookup
 * @param {String} cssProperty CSS Property to set/update
 * @param {Object} cssPropertyValue Value to use
 */
const setCSSForElements =
    (selector, cssProperty, cssPropertyValue) =>
        document.querySelectorAll(selector).forEach(el => el.style[cssProperty] = cssPropertyValue);

const showElement = (element) => {
    // Legacy, remove once jQuery library is removed
    if(element instanceof jQuery) {
        if (isEmpty(element)) {
            return;
        }

        if (element.css('visibility').equalsIgnoreCase('hidden')) {
            element.css('visibility', 'visible');
        } else {
            element.show();
        }
        return;
    }

    let el = getElement(element);
    if(!isUndefinedOrNull(el)){
        if(getComputedStyle(el).visibility.equalsIgnoreCase('hidden')){
            el.style.visibility = 'visible';
        }
        else {
            if(getComputedStyle(el).display === 'none'){
                el.style.display = el.dataset.xxxDisplay || 'block';
            }
        }
    }
};

function showElements(elements) {
    // Legacy, remove once jQuery library is removed
    if(elements instanceof jQuery) {
        if (isEmpty(elements)) {
            return;
        }
        showElement(elements);
        return ;
    }

    elements = getElements(elements) || [];
    elements.forEach(element => showElement(element));
}

const waitAndGetAddToCartButton = () => waitForElement(ADD_TO_CART_COMPONENT);

function waitForElement(selector) {
    return new Promise(resolve => {
        if (document.querySelector(selector)) {
            return resolve(document.querySelector(selector));
        }

        new MutationObserver((mutations, observer) => {
            if (document.querySelector(selector)) {
                resolve(document.querySelector(selector));
                observer.disconnect();
            }
        }).observe(document.body, {
            childList: true,
            subtree: true
        });
    });
}

function waitForAllElement(selector) {
    return new Promise(resolve => {
        if (document.querySelectorAll(selector)) {
            return resolve(document.querySelectorAll(selector));
        }

        new MutationObserver((mutations, observer) => {
            Array.from(document.querySelectorAll(selector)).forEach((element) => {
                resolve(element);
                observer.disconnect();
            });
        }).observe(document.body, {
            childList: true,
            subtree: true
        });
    });
}